// 會員個人資料的固定選項；與後端 utils/voteConst.js 的 GENDERS / REGIONS 對應，
// 兩邊是同一份定義的兩側，改一邊就要改另一邊（送到後端的是 value）
export const GENDERS = [
  { value: 'male', label: '男性' },
  { value: 'female', label: '女性' },
  { value: 'undisclosed', label: '不透露' }
]

export const REGIONS = [
  { value: 'north', label: '北部' },
  { value: 'central', label: '中部' },
  { value: 'south', label: '南部' },
  { value: 'east', label: '東部' },
  { value: 'island', label: '離島' }
]

// 登入平台的顯示名稱（會員中心的「使用○○登入」）
export const PLATFORM_LABEL = { google: 'Google', line: 'LINE', h2u: '健行筆記' }

// 投票前必須填齊的個人資料；與後端 utils/participantProfile.js 同一份判斷，改一邊就要改另一邊
export const PROFILE_REQUIRED_FIELDS = ['nickname', 'gender', 'birthday', 'email', 'region']

// 後端投票介面擋下「個人資料未填齊」時回的業務代碼
export const PROFILE_INCOMPLETE_CODE = 428

export const isProfileComplete = (user) =>
  Boolean(user) && PROFILE_REQUIRED_FIELDS.every((key) => String(user[key] ?? '').trim() !== '')
